function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
  points: "9 14 4 9 9 4",
  transform: "translate(0,-0.5)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 19.989703,14.424261 20,12.5 c 0.01182,-2.209107 -1.790861,-4 -4,-4 H 4"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m 20,12.15574 v 4.203883 c 0,2.209139 -1.790861,4 -4,4 H 4"
}));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/return.bb5f0f34.svg";
export { SvgComponent as ReactComponent };